import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/core/app.state";
import { CategoriesService } from "../services/categories.services";
import { CommonService } from "src/app/shared/common.service";
import * as categoriesActions  from "./categories.actions"
import { catchError, finalize, map, of, switchMap, tap } from "rxjs";
import { APIResponse } from "src/app/core/models/api-response";
import { ICategory } from "../models/categories.models";
import { AlertEnums } from "src/app/shared/enums/shared.enums";
import { TranslateService } from "@ngx-translate/core";
import { DEFAULT_PAGE_SIZE } from "src/app/config/global.config";

@Injectable()
export class CategoriesEffects {
  constructor(
    private actions$: Actions,
    public store: Store<AppState>,
    private categoriesServices: CategoriesService,
    private commonService: CommonService,
    private translateService: TranslateService
  ) { }

      // fetch All Categories
      FetchAllCategoriesEffect$ = createEffect(() =>
        this.actions$.pipe(
          ofType(categoriesActions.FetchAllCategories),
          tap(() => {
            this.store.dispatch(categoriesActions.SetCategoriesLoader({ isLoading: true }));
          }),
          switchMap(({ includes }) =>
            this.categoriesServices.listAllCategories(includes).pipe(
              map((res: APIResponse<ICategory>) => categoriesActions.FetchAllCategoriesSuccess({ categories: res })),
              catchError(() => of(
                categoriesActions.FetchAllCategoriesError()
              )),
              finalize(() => {
                this.store.dispatch(categoriesActions.SetCategoriesLoader({ isLoading: false }));
              })
            )
          ),
        )
      );
    // fetch Categories
    FetchCategoriesEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(categoriesActions.FetchCategories),
        tap(() => {
          this.store.dispatch(categoriesActions.SetCategoriesLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          this.categoriesServices.listCategories(action.page, action.key).pipe(
            map((res: APIResponse<ICategory>) => categoriesActions.FetchCategoriesSuccess({ categories: res })),
            catchError(() => of(
              categoriesActions.FetchCategoriesError()
            )),
            finalize(() => {
              this.store.dispatch(categoriesActions.SetCategoriesLoader({ isLoading: false }));
            })
          )
        ),
      )
    );


    // add Category
    AddCategoryEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(categoriesActions.AddCategory),
        tap(() => {
          this.store.dispatch(categoriesActions.SetCategoriesLoader({ isLoading: true }));
        }),
        switchMap((action) =>
          this.categoriesServices.addCategory(action.category).pipe(
            map((res: APIResponse<ICategory>) => categoriesActions.AddCategorySuccess({ categories: res.data })),
            tap(() => {
              this.store.dispatch(categoriesActions.FetchCategories({ page: {number:1, size: DEFAULT_PAGE_SIZE} }));
              this.commonService.showToast(
                this.translateService.instant(`alerts.${AlertEnums.categoryAddSuccess}`),
                'SUCCESS'
              );
            }),
            catchError(() => of(categoriesActions.AddCategoryError())),
            finalize(() => {
              this.store.dispatch(categoriesActions.SetCategoriesLoader({ isLoading: false }));
            })
          )
        ),
      )
    );


  // update Category
  UpdateCategoryEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(categoriesActions.UpdateCategory),
      tap(() => {
        this.store.dispatch(categoriesActions.SetCategoriesLoader({ isLoading: true }));
      }),
      switchMap((action) =>
        this.categoriesServices.updateCategory(action.id, action.category).pipe(
          map((res: APIResponse<ICategory>) => categoriesActions.UpdateCategorySuccess({ category: res.data[0] })),
          tap(() => {
            this.store.dispatch(categoriesActions.FetchCategories({ page: {number:1, size: DEFAULT_PAGE_SIZE} }));
            this.commonService.showToast(
              this.translateService.instant(`alerts.${AlertEnums.categoryUpdateSuccess}`),
              'SUCCESS'
            );
          }),
          catchError(() => of(categoriesActions.UpdateCategoryError())),
          finalize(() => {
            this.store.dispatch(categoriesActions.SetCategoriesLoader({ isLoading: false }));
          })
        )
      )
    )
  );

  // delete Category
  deleteCategoryEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(categoriesActions.DeleteCategory),
      tap(() => {
        this.store.dispatch(categoriesActions.SetCategoriesLoader({ isLoading: true }));
      }),
      switchMap((action) =>
        this.categoriesServices.deleteCategory(action.id).pipe(
          map((res: APIResponse<ICategory>) => categoriesActions.DeleteCategorySuccess()),
          tap(() => {
            this.commonService.showToast(
              this.translateService.instant(`alerts.${AlertEnums.categoryDeleteSuccess}`),
              'SUCCESS'
            );
          }),
          catchError(() => of(categoriesActions.DeleteCategoryError())),
          finalize(() => {
            this.store.dispatch(categoriesActions.SetCategoriesLoader({ isLoading: false }));
          })
        )
      )
    )
  );
}
